import {
  ActivityCategory,
  ActivityWithCategoryAndLocationsAndReportedDetails,
  GeoLocation,
  OperationStatus,
  OrganizationalUnit,
} from '@wilson/interfaces';
import { WilsonApp } from '@wilson/interfaces';
import { CreateNewViaDragAndDropService } from '../create-new-via-drag-and-drop.service';
import { createFullActivityObject } from '@wilson/non-domain-specific/activities-helpers/services';

export function generateDummyActivity({
  orgUnit,
  location,
  activityStartDate,
  activityEndDate,
  activityCategoryId,
}: {
  orgUnit: OrganizationalUnit;
  location: GeoLocation;
  activityStartDate: string;
  activityEndDate: string;
  activityCategoryId: string;
}): ActivityWithCategoryAndLocationsAndReportedDetails {
  return {
    ...createFullActivityObject(),
    id: CreateNewViaDragAndDropService.MOCK_ACTIVITY_ID,
    activityCategoryId: activityCategoryId,
    activityReports: [],
    activityCategory: {
      id: '73b6f3fc-8d47-4cd0-8e4a-a3a3756e8ce7',
      version: 1,
      name: 'train-drive',
      isMain: true,
      isPayableTime: true,
      isProductiveTime: true,
      sectorIds: [],
      isEnabled: false,
      nameDe: 'train-drive',
      nameEn: 'train-drive',
      nameFr: 'train-drive',
      namePl: 'train-drive',
      translatedName: 'train-drive',
    } as ActivityCategory & { translatedName: string },
    createdFrom: WilsonApp.Portal,
    endDatetime: activityEndDate,
    endLocationId: orgUnit.locationId as string,
    endLocation: location,
    jobId: null,
    name: '',
    operationalStatus: OperationStatus.NotStarted,
    professionId: null,
    serviceId: null,
    shiftId: null,
    startDatetime: activityStartDate,
    startLocationId: orgUnit.locationId as string,
    startLocation: location,
    viaLocationIds: [],
    reportedStartDatetime: null,
    reportedEndDatetime: null,
    reportedStartLocationId: null,
    reportedEndLocationId: null,
  };
}
